const STATUS = Object.freeze({
  REFUND: "REF",
  PENDING: "PND",
  PAID: "PAI",
  UNPAID: "UNP",
  CANCELLED: "CAN",
});

const TYPE = Object.freeze({
  PENDING: "pending",
  FINISHED: "finished",
  ALL: "all",
  INDEMNIZATION: "IND",
  RESERVE: "RES",
  FINISHED_TRAVEL: "FTR",
  PENALIZATION: "PEN",
  ADDITIONAL_LIQUIDATION: "IND",
  SUBSCRIPTION: "SBF",
  RESERVE_EXTENDED: "EXR",
  RESERVE_CANCELLED: "CRE",
  REFUND: "REF",
  ENTRY: "ENT",
  SHORT: "SHR",
});

const ACTION = Object.freeze({
  PAY: "pay",
  CONVERT_TO_RECEIPT: "convert",
  SEND_TO_MAIL: "sendToMail",
  SEND_TO_SII: "sendToSII",
  MAKE_RETURN: "makeRetun",
  CANCEL: "CANCEL",
  PARCIAL_PAYMENT: "PARCIAL_PAYMENT",
  MODIFY: "MODIFY",
  FORCE_COLLECTION: "FORCE_COLLECTION",
  CHANGE_TO_OFFLINE: "CHANGE_TO_OFFLINE",
  CHANGE_TO_ONLINE: "CHANGE_TO_ONLINE",
  PAY_ON_ACCOUNT: "payOnAccount",
  REGENERATE_DOCUMENT: "regenerateDocument",
  UNGROUP: "ungroup",
  CHANGE_ONLINE_OFFLINE: "changeOnlineOffline",
  CREATE_PAYMENT_LINK: "generatePaymentLink",
  SEND_TO_ERP: "sendToERP",
});

const METHOD = Object.freeze({
  BECS: "BECS",
  SEPA: "SEPA",
  CREDIT_CARD: "CREDIT_CARD",
});

const PLATFORM = Object.freeze({
  REDSYS: "RED",
  STRIPE: "STR",
});

const PAYER_TYPE = Object.freeze({
  USER: "USER",
  COMPANY: "COMP",
});

const CHARGE_FILTER_INVOICED = Object.freeze({
  TODAY: "TOD",
  YESTERDAY: "YES",
  LAST_WEEK: "LWE",
  CURRENT_MONTH: "CMO",
  PREVIOUS_MONTH: "PMO",
  CURRENT_YEAR: "CYE",
  PREVIOUS_YEAR: "PYE",
});

const LOG_TYPE = Object.freeze({
  CREATION: "CRE",
  MODIFICATION: "MOD",
  LINKED: "LIN",
  UNLINKED: "UNL",
  PAID: "CPA",
  UNPAID: "CUN",
  RETURN: "RET",
  INVOICE: "INV",
  REGENERATE_DOCUMENT: "RED",
  SEND_BY_EMAIL: "SMA",
});

const ODOO_STATUS = Object.freeze({
  NOT_SENT: "NOT_SENT",
  SENT: "SENT",
  SYNC_ERROR: "SYNC_ERROR",
});

export default Object.freeze({
  STATUS: STATUS,
  TYPE: TYPE,
  ACTION: ACTION,
  METHOD: METHOD,
  PLATFORM: PLATFORM,
  PAYER_TYPE: PAYER_TYPE,
  FILTER_INVOICED: CHARGE_FILTER_INVOICED,
  LOG_TYPE: LOG_TYPE,
  ODOO_STATUS: ODOO_STATUS,
});
